import type { BillingStatus } from '@/types';
import type { User, Company } from '@/types';

/** Shared plan resolution for trial banners and write guards (see TrialBanner v3.5.2). */
export function resolveTrialPlanContext(
  user: User | null | undefined,
  selectedCompany: Company | null | undefined,
  billingStatus: BillingStatus | null | undefined,
) {
  const userBillingPlanId = user?.billing?.planId;
  const companyPlanIdSnapshot = (selectedCompany as { billing?: { planId?: string } } | null)
    ?.billing?.planId;
  const currentPlanId = billingStatus?.planId ?? userBillingPlanId ?? companyPlanIdSnapshot;

  const isAgencyOwnerEffective =
    user?.accountType === 'agency_owner' ||
    Boolean(user?.agencyPlanId) ||
    (userBillingPlanId?.startsWith('agency_') ?? false) ||
    (currentPlanId?.startsWith('agency_') ?? false);

  const onPaidPlan = !!currentPlanId && currentPlanId !== 'freemium_trial';

  return {
    userBillingPlanId,
    companyPlanIdSnapshot,
    currentPlanId,
    isAgencyOwnerEffective,
    onPaidPlan,
  /** Company-scoped billing from GET /billing/status has loaded at least once. */
  billingResolved: !selectedCompany?.id || billingStatus !== undefined,
  };
}

export function isTrialExpiredForCompany(trial: {
  active?: boolean;
  isExpired?: boolean;
  status?: string;
} | null | undefined): boolean {
  return Boolean(
    trial?.active && (trial.isExpired || trial.status === 'expired'),
  );
}
